import { vars } from '@app/config'
import { getCookie } from '@app/services'

import { Profile } from './types'

export const getProfileFromCookie = (): Profile | null => {
  const profile = getCookie(vars.b2c_profile)
  if (profile) {
    try {
      const decodedProfile = decodeURIComponent(profile)
      return JSON.parse(decodedProfile)
    } catch (error) {
      console.error('Failed to decode or parse profile from cookie', error)
      return null
    }
  }
  return null
}
